import Cookies from "js-cookie";

declare global {
    interface Window {
        dataLayer: any[];
        gtag: (...args: any[]) => void;
    }
}

// const GA_MEASUREMENT_ID = "G-XXXXXXX";
const GA_MEASUREMENT_ID = "G-G7XRFEDQZ0";
/* ✅ INIT ANALYTICS */
export const initAnalyticsTracking = () => {

    const prefs = Cookies.get("cookiePreferences");
    if (!prefs) return;

    const parsed = JSON.parse(prefs);

    if (!parsed.analytics) {
        return;
    }



    // Prevent duplicate load
    if (document.getElementById("ga-script")) return;

    const script = document.createElement("script");
    script.id = "ga-script";
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());

    window.gtag("config", GA_MEASUREMENT_ID, {
        anonymize_ip: true, // GDPR safe
    });
};

/* 📄 PAGE VIEW TRACKING */
export const trackPageView = (pagePath: string) => {
    if (!window.gtag) return;

    window.gtag("event", "page_view", {
        page_path: pagePath,
    });


};

/* 🎯 CUSTOM EVENT TRACKING */
export const trackEvent = (
    eventName: string,
    params: Record<string, any> = {}
) => {
    if (!window.gtag) return;

    window.gtag("event", eventName, params);


};
